<template>
	<div class="RegistWarp">
		<div class="Registbox">
			<div class="leftwarp">
				<div class="imgbox">
					<img src="@/assets/imgs/login/logo1.png" />
				</div>
				<div class="handleBox">
					<div class="loginbtn" @click="gologin">登录</div>
					<div class="registbtn">注册</div>
				</div>
				<div class="formbox">
					<div class="btnbox">
						<div v-for="(item,index) in btntype" :key="index" :class="activebtnname==item.name?'activename':'name'" @click="changeTypeFn(item)">{{item.name}}</div>
					</div>
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="formwarp" label-position='top'>
						<el-form-item label="用户名" prop="userName">
							<el-input v-model="ruleForm.userName" placeholder="请输入用户名(建议为'拼音+数字'组合)"></el-input>
						</el-form-item>
						<el-form-item label="姓名" prop="names">
							<el-input v-model="ruleForm.names"></el-input>
						</el-form-item>
						<el-form-item label="单位名称" :prop="activebtnname=='单位用户'?'corpInfoName':''">
							<el-input v-model="ruleForm.corpInfoName" @keyup.enter.native="registEnterFn"></el-input>
						</el-form-item>
						<el-form-item label="手机号" prop="phoneNumber">
							<el-row :gutter="20">
								<el-col :span="24">
									<el-input v-model="ruleForm.phoneNumber" @blur='blurFn($event.target.value)'></el-input>
								</el-col>
								<!-- <el-col :span="6" style="padding:0px">
										<div class="getcodebtn" @click="getcodeFn">
											<el-button :disabled='disable'>{{showtimeContent}}</el-button>
										</div>
									</el-col> -->
							</el-row>
						</el-form-item>
						<!-- <el-form-item label="验证码" prop="identfyCode">
						<el-input v-model="ruleForm.identfyCode"></el-input>
					</el-form-item> -->
						<el-form-item label="密码" prop="password">
							<el-input type="password" v-model="ruleForm.password" @keyup.enter.native="registEnterFn" show-password></el-input>
						</el-form-item>
						<el-form-item label="再次输入密码" type="password" prop="affirmpassword">
							<el-input type="password" v-model="ruleForm.affirmpassword" @keyup.enter.native="registEnterFn" show-password></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" class="savebtnbox" @click="submitForm('ruleForm')" style="width:100%" :loading="isloading">注册</el-button>
						</el-form-item>
					</el-form>
				</div>
				<div class="tiptext">
					如果您有任何疑问或在登录过程中遇到任何困难，您都可以通过以下方式与我们联系 电话：010-88824565
				</div>
			</div>
			<div class="rightwarp">
				<img src="@/assets/imgs/login/logo2.png" />
				<div class="textBox">
					<div>欢迎注册</div>
					<div>中国人才交流协会</div>
				</div>
			</div>
			<!-- 注册完成之后申请入会 -->
			<el-dialog title="" :visible.sync="dialogVisible" width="720px" class="dialogWarp" :destroy-on-close="true" :close-on-click-modal='false'>
				<div class="dialogcenterbox">
					<div class="text1">您已注册成功</div>
					<div class="text2">是否立即申请成为中国人才交流协会会员？</div>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="okFn">立即入会并登录</el-button>
					<el-button @click="cancelFn">暂不</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>
<script>
import { httpService } from "@/service/httpService";
export default {
	data() {
		var validatePass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.ruleForm.password) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		let checkData = (rule, value, callback) => {
			if (value) {
				if (/[\u4E00-\u9FA5]/g.test(value)) {
					callback(new Error('用户名不能输入汉字!'));
				} else {
					callback();
				}
			}
			callback();
		}
		return {
			showtime: '',
			showtimeContent: '发送验证码',
			disable: true,
			isloading: false,
			btntype: [
				{ name: '单位用户' },
				{ name: '个人用户' },
			],
			activebtnname: '单位用户',
			ruleForm: {
				userName: '',
				names: '',
				corpInfoName: '',
				phoneNumber: '',
				// identfyCode: '',
				password: '',
				affirmpassword: '',
				userType: ''
			},
			rules: {
				userName: [
					{ required: true, message: '请输入用户名,用户名建议以"拼音+数字"组合', trigger: 'blur' },
					// {

					// 	required: true, message: '用户名不能输入中文', pattern: /[\u4E00-\u9FA5]/g, trigger: 'blur'
					// }
					{ validator: checkData, trigger: 'blur' }

				],
				names: [
					{ required: true, message: '请输入姓名', trigger: 'blur' },
				],
				// {activebtnname=='单位用户'?corpInfoName: [
				// 	{ required: true, message: '请输入单位名称', trigger: 'blur' },
				// ]:'',
				// }
				corpInfoName: [
					{ required: true, message: '请输入单位名称', trigger: 'blur' },
				],
				phoneNumber: [
					{ required: true, message: '请输入手机号', trigger: 'blur' },
					{
						required: true, message: '请输入正确的手机号码', pattern: /^1[3|4|5|7|8][0-9]\d{8}$/, trigger: 'blur'
					}
				],
				identfyCode: [
					{ required: true, message: '请输入验证码', trigger: 'blur' },
				],
				password: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
				],
				affirmpassword: [
					{ required: true, message: '请再次确认密码', trigger: 'blur' },
					{ validator: validatePass2, trigger: 'blur', required: true }
				],
			},
			dialogVisible: false,
		}
	},
	methods: {
		changeTypeFn(val) {
			this.activebtnname = val.name
			this.$refs["ruleForm"].clearValidate()
		},
		registEnterFn() {
			this.submitForm('ruleForm')
		},
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.isloading = true
					if (this.activebtnname == '单位用户') {
						this.ruleForm.userType = 3
					} else {
						this.ruleForm.userType = 4
					}
					httpService.registFn(this.ruleForm).then(res => {
						if (res) {
							this.isloading = false
							if (res.code == 200) {
								// 存userId
								sessionStorage.setItem('nologinuserId', res.result)
								this.dialogVisible = true
							} else {
								this.$message.error(res.message);
							}
						}

					});
				} else {
					return false;
				}
			});
		},
		gologin() {
			this.$router.push('/login');
		},
		blurFn(value) {
			if (value) {
				this.disable = false
			}
		},
		async getcodeFn() {
			let data = await httpService.phoneCodeFn(this.ruleForm.phoneNumber);
			if (data.code == 200) {
				this.showtime = 120,
					this.showtimeContent = '已发送'
				this.disable = true
				// this.newsData = data.result.list
				let timeChange;
				//关键在于用ti取代time进行计算和判断，因为time在render里不断刷新，但在方法中不会进行刷新
				const clock = () => {
					let ti = this.showtime;
					if (ti > 1) {
						//当ti>0时执行更新方法
						ti = ti - 1;
						this.showtime = ti,
							this.showtimeContent = '已发送' + ti + 's'
					} else {
						//当ti=0时执行终止循环方法
						clearInterval(timeChange);
						this.showtime = '',
							this.showtimeContent = '发送验证码',
							this.disable = false
					}
				};

				// 弹框
				if (this.disable) {
					//每隔一秒执行一次clock方法
					timeChange = setInterval(clock, 1000);
				} else {
					clearInterval(timeChange);
				}
			}
		},
		// 立即入会
		async	okFn() {
			let formobj = {
				userName: this.ruleForm.userName,
				password: this.ruleForm.password,
			}
			let res = await httpService.loginFn(formobj)
			if (res.code == 200) {
					let data = res.result
				sessionStorage.setItem('token', data.token)
				sessionStorage.setItem('userInfo', JSON.stringify(data.principal.loginVo))
				this.dialogVisible = false
				this.$router.push('/account-center/member-ship')
			} else {
				this.$message.error(res.message)
			}
		},
		cancelFn() {
			this.dialogVisible = false
			this.$router.push('/login')
		}
	}
}
</script>
<style lang="less" scoped>
.RegistWarp {
	background: url(../assets/imgs/login/img1.png) #fff no-repeat;
	background-size: 100% 100%;
	// overflow: hidden;
	width: 100%;
	height: 100%;
	// top: 0;
	// bottom: 0;
	// left: 0;
	// right: 0;
	// margin: 0 auto;
	margin: auto;
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	box-sizing: border-box;
	.Registbox {
		width: 1200px;
		margin: 0 auto;
		padding: 10px 0 0px 0px;
		box-sizing: border-box;
		box-sizing: border-box;
		max-height: 900px;
		// background: url(../assets/imgs/login/img1.png) #fff;
		display: flex;
		flex-direction: row;
		box-sizing: border-box;
		.leftwarp {
			display: flex;
			flex-direction: column;
			width: 588px;
			align-items: center;
			.imgbox {
				width: 98px;
				height: 98px;
				background: #fff;
				box-shadow: 0px 15px 16px rgba(0, 0, 0, 0.07);
				border-radius: 12px;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-bottom: 30px;
				img {
					width: 65px;
					height: 60px;
					// margin: auto 0;
					margin: 17px 15px;
				}
			}
			.handleBox {
				width: 100%;
				display: flex;
				flex-direction: row;
				justify-content: space-around;
				padding: 0 100px;
				box-sizing: border-box;
				margin-bottom: 26px;
				.loginbtn {
					font-size: 24px;
					color: #333333;
					cursor: pointer;
				}
				.registbtn {
					font-size: 24px;
					color: #0083ff;
				}
			}
			.formbox {
				// height: 712px;
				box-shadow: 0px 3px 10px rgba(232, 232, 232, 0.52);
				background: #fff;
				.btnbox {
					display: flex;
					flex-direction: row;
					justify-content: center;
					font-size: 20px;
					line-height: 24px;
					margin: 27px 0 20px 0;
					.activename {
						color: #0083ff;
						cursor: pointer;
						position: relative;
						margin: 0 50px;
						padding-bottom: 10px;
						border-bottom: 1px solid #0083ff;
					}
					.name {
						cursor: pointer;
						color: #43424b;
						margin: 0 50px;
						padding-bottom: 10px;
					}
				}
				.formwarp {
					width: 588px;
					box-sizing: border-box;
					padding: 0px 73px 16px 73px;
					.getcodebtn {
						/deep/.el-button {
							border: none;
							width: 104px;
							height: 45px;
							background: rgba(0, 131, 255, 0.1);
							color: #0083ff;
							font-size: 16px;
							text-align: center;
							padding: 0;
						}
					}
					/deep/.el-form-item {
						margin-bottom: 16px;
					}
					/deep/.el-form-item__label {
						line-height: 0;
					}
					/deep/.el-input__inner {
						height: 45px;
						line-height: 45px;
					}
					.savebtnbox {
						height: 45px;
						background: #0083ff;
						font-size: 16px;
						box-shadow: 0px 7px 22px rgba(103, 154, 255, 0.44);
						margin-top: 20px;
					}
				}
			}
			.tiptext {
				width: 560px;
				font-size: 16px;
				line-height: 24px;
				color: #a6a9b7;
				margin: 21px 0;
			}
		}
		.rightwarp {
			margin: 200px 0 0 120px;
			.textBox {
				font-size: 60px;
				font-weight: bold;
				line-height: 88px;
				color: #ffffff;
				margin-top: 22px;
			}
		}
		/deep/.dialogcenterbox {
			padding: 0px 0 90px 0;
			display: flex;
			flex-direction: column;
			align-items: center;
			.text1 {
				font-size: 22px;
				font-weight: bold;
				line-height: 32px;
				color: #333333;
				margin: 46px 0;
			}
			.text2 {
				font-size: 16px;
				line-height: 30px;
				color: #666666;
			}
		}
	}
}
</style>


